export default __webpack_public_path__ + "static/media/airbnb-circle-300x300.2135928c.png";